import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import { StyledContainer } from "./styles";
import classnames from "classnames";
import Textarea from "react-textarea-autosize";
import Card from "..";
import { CardContext } from "../..";
import { CONVERT_GROUP_ACTION, SET_CONTENT_ACTION } from "../../hooks/useCanvasReducer";
import InlineSVG from "react-inlinesvg/esm";
import { CANVAS_OUTLINE_TYPES, OUTLINE_HEADER_CARD_TYPE } from "../../../../../../src/shared/canvasConstants";
import FillingButton from "../../../FillingButton";
import Picker from "./Picker";
import Menu from "./Menu";

const MAX_CHARACTER_COUNT = 2500;

export default function OutlineHeaderCard({
  x, //
  y,
  content,
  title,
  placeholder,
  width,
  height,
  id,
  selected,
  type,
  zoom,
  generating,
  index,
  initialEditing = false,
  autoHeight,
  data,
}) {
  const {
    selectedCardIds, //
    setIsEditing,
    dispatch,
    isSpaceDown,
    generateOutline,
    cards,
    groups,
    getConfirmation,
    deselectAllCards,
  } = useContext(CardContext);

  const [loading, setLoading] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);

  const editingRef = useRef(null);

  // true if this is the only card selected
  const onlyThisSelected = selected && selectedCardIds.length === 1;

  useEffect(() => {
    setIsEditing(pickerOpen);
  }, [pickerOpen]);

  // determine if the outline has been "touched"
  const groupIds = Object.keys(groups).find((gid) => groups[gid].cards.includes(id));

  let touched = true;
  let cardIds = null;
  if (groupIds) {
    cardIds = groups[groupIds]?.cards;
    if (cardIds) {
      touched = cardIds.find((cid) => cards[cid].type !== OUTLINE_HEADER_CARD_TYPE && cards[cid]?.content?.length > 0);
    }
  }

  const typeItem = CANVAS_OUTLINE_TYPES.find((item) => item.value === data.type);

  const setType = useCallback(async ({ type, concept }) => {
    if (touched && type !== data.type) {
      const confirm = await getConfirmation("Are you sure? Changing the story structure will delete your current outline.");

      if (!confirm) {
        return false;
      }
    }
    // convert it
    dispatch({ type: CONVERT_GROUP_ACTION, outlineType: type, id: id });

    if (concept) {
      dispatch({ type: SET_CONTENT_ACTION, id: id, content: concept });
    }

    return true;
  }, [touched, data, id]);

  return (
    <Card
      x={x}
      y={y}
      content={content}
      width={width}
      height={height}
      minSize={null}
      id={id}
      selected={selected}
      type={type}
      zoom={zoom}
      generating={false}
      generatable={false}
      index={index}
      autoHeight={true}
    >
      {pickerOpen && (
        <Picker
          close={() => setPickerOpen(false)} //
          initialType={typeItem.value}
          commitType={setType}
        />
      )}
      <StyledContainer className={classnames("textarea-container")}>
        {cardIds && <Menu cardIds={cardIds} cards={cards} />}

        <div className="title">OUTLINE</div>

        <div className="type">
          <a onClick={(e) => setPickerOpen(true)}>{typeItem.label} <InlineSVG src="/assets/down-arrow.svg" /> </a>
        </div>

        <Textarea
          maxLength={MAX_CHARACTER_COUNT}
          placeholder={"Type in the concept for your story. Include important details about the characters and plot."}
          className="editable no-drag"
          ref={editingRef}
          disabled={isSpaceDown || loading}
          onBlur={(e) => setIsEditing(false)}
          onFocus={(e) => {
            setIsEditing(true);
            deselectAllCards({ exceptId: id });
          }}
          onChange={(e) => {
            dispatch({ type: SET_CONTENT_ACTION, id: id, content: e.target.value });
            e.stopPropagation();
          }}
          value={content}
        />

        <div className="submit">
          <FillingButton
            disabled={loading || content?.length === 0}
            filling={loading}
            seconds={45}
            spinner
            onClick={(e) => {
              e.preventDefault();
              setLoading(true);
              generateOutline({ headerCardId: id }).then(() => {
                setLoading(false);
              });
            }}
          >
            ✨ Generate full outline
          </FillingButton>
        </div>
      </StyledContainer>
    </Card>
  );
}
